export default {"src":"/_next/static/media/login_bg.407cd9ab.svg","height":645,"width":1440,"blurWidth":0,"blurHeight":0};